// removed by extract-text-webpack-plugin
module.exports = {"productProp":"productProp__2bWQGHkP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYFilter/components/OYProductProp/index.module.less
// module id = 743
// module chunks = 1